import { useCallback, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Header.scss";
import ButtonComponent from "../common/ButtonComponent";
import UserAccount from "../UserAccount";
import Logo from "../../assets/branding-image/app_logo.svg";
import { APP_CONST } from "../../Constants/app.constant";
import { ROUTE_CONST } from "../../Constants/route.constant";
import shareIcon from "../../assets/images/shareIcon.svg";
import documentationIcon from "../../assets/images/resourcesIcon.svg";
import { handleKeyboardEvent, openDocumentation } from "../../utils/Helper";

const Header = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActiveTab = useCallback(
    (_title, path) => pathname === path,
    [pathname]
  );

  useEffect(() => {
    const activeTab = APP_CONST.TABS_HEADERS.find(
      (tab) => tab.path === pathname
    );
    const currentTitle = activeTab?.title || activeTab?.label || "Marketplace";
    const newTitle = `${APP_CONST.APPLICATION_NAME} - ${currentTitle}`;

    if (document.title !== newTitle) {
      document.title = newTitle;
    }
  }, [pathname]);

  const handleTabClick = useCallback(
    (_title, path) => {
      navigate(path);
    },
    [navigate]
  );

  const handleLogoClick = useCallback(() => {
    navigate(ROUTE_CONST.HOME);
    document.title = `${APP_CONST.APPLICATION_NAME} - Marketplace`;
  }, [navigate]);

  const handleDocumentation = () => {
    openDocumentation();
  };

  return (
    <div className="authenticateHeader">
      <div className="headerSection d-flex">
        <div className="logo-wrap">
          <button
            type="button"
            className="logo-content logo-btn"
            onClick={handleLogoClick}
            onKeyDown={(e) => {
              handleKeyboardEvent(e, handleLogoClick);
            }}
            aria-label="Home"
          >
            <img src={Logo} alt="logo" className="logo" loading="lazy" />
          </button>
        </div>

        <div className="tabs-section">
          <ul className="inner-tabs">
            {APP_CONST.TABS_HEADERS.map(({ title, path }) => (
              <li key={`${path}-${title}`}>
                <button
                  type="button"
                  role="tab"
                  aria-selected={isActiveTab(title, path)}
                  tabIndex={0}
                  className={`tab-list-item text-uppercase${isActiveTab(title, path) ? " active" : ""}`}
                  onClick={() => handleTabClick(title, path)}
                  onKeyDown={(e) => {
                    handleKeyboardEvent(e, () => handleTabClick(title, path));
                  }}
                >
                  {title}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="headerRightSection d-flex align-items-center justify-content-end">
            <button
              type="button"
              className="header-icon-btn"
              onClick={handleDocumentation}
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title="Documentation"
              aria-label="Documentation"
            >
              <img
                src={documentationIcon}
                alt="documentation"
                className="header-icon"
                aria-hidden="true"
              />
            </button>
            <ButtonComponent
              title={APP_CONST.APP_FOUNDRY}
              buttonClass="share-icon-button"
              onClickHandler="/studio/home"
              icon={shareIcon}
            />
            <UserAccount />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;